import { render, staticRenderFns } from "./ConfigStore.vue?vue&type=template&id=ecc990b0&scoped=true&"
import script from "./ConfigStore.vue?vue&type=script&lang=js&"
export * from "./ConfigStore.vue?vue&type=script&lang=js&"
import style0 from "./ConfigStore.vue?vue&type=style&index=0&id=ecc990b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecc990b0",
  null
  
)

export default component.exports